/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';

// material-ui
import { Button, CardContent, CardActions, Divider, Grid, IconButton, Modal, Typography } from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';

// assets
import CloseIcon from '@mui/icons-material/Close';
import { ListingActions } from 'store/slices/listings';

// generate random
function rand() {
    return Math.round(Math.random() * 20) - 10;
}

// modal position
function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`
    };
}

const formatDate = (isoString) => {
    const date = new Date(isoString);
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    };
    return date.toLocaleString(undefined, options);
};

const Body = React.forwardRef(({ modalStyle, handleClose, selectedRow }, ref) => (
    <div ref={ref} tabIndex={-1}>
        <MainCard
            style={modalStyle}
            sx={{
                position: 'absolute',
                width: { xs: 280, lg: 450 },
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }}
            title="Property Details"
            content={false}
            secondary={
                <IconButton onClick={handleClose} size="large">
                    <CloseIcon fontSize="small" />
                </IconButton>
            }
        >
            <CardContent>
                <Typography variant="h4">{selectedRow?.name || 'No Data Available'}</Typography>
                <Typography variant="body2" sx={{ mt: 2 }}>
                    <b>Info:</b> {selectedRow?.description || ''}
                </Typography>
                <Typography variant="body2" sx={{ mt: 2 }}>
                    <b>Address:</b> {selectedRow?.address || ''}
                </Typography>
                <Typography variant="body2" sx={{ mt: 2 }}>
                    <b>Status:</b> {selectedRow?.type || ''}, {selectedRow?.status || ''}, {selectedRow?.listingStatus || ''}
                </Typography>
                <Typography variant="body2" sx={{ mt: 2 }}>
                    <b>Lister Info:</b> {selectedRow?.lister?.firstName || ''}, {selectedRow?.lister?.email || ''},{' '}
                    {selectedRow?.lister?.phoneNo || ''}, {selectedRow?.lister?.address || ''}
                </Typography>
                <Typography variant="body2" sx={{ mt: 2 }}>
                    <b>Owner Info:</b> {selectedRow?.contactInfo?.name || ''}, {selectedRow?.contactInfo?.email || ''},{' '}
                    {selectedRow?.contactInfo?.phone || ''}
                </Typography>
                <Typography variant="body2" sx={{ mt: 2 }}>
                    <b>Rent Info:</b> {selectedRow?.rentDetails?.currency || ''}, {selectedRow?.rentDetails?.rent || ''},{' '}
                    {selectedRow?.rentDetails?.type || ''}
                </Typography>
                <Typography variant="body2" sx={{ mt: 2 }}>
                    <b>Listed On:</b> {formatDate(selectedRow?.createdAt) || ''}
                </Typography>
                <Typography variant="body2" sx={{ mt: 2 }}>
                    <b>Last Update On:</b> {formatDate(selectedRow?.updatedAt) || ''}
                </Typography>
            </CardContent>
            <CardActions>
                <DetailsModal />
            </CardActions>
        </MainCard>
    </div>
));

Body.propTypes = {
    modalStyle: PropTypes.object,
    handleClose: PropTypes.func
};

// ==============================|| SIMPLE MODAL ||============================== //

export default function DetailsModal({ open, setOpen, selectedRow }) {
    const [modalStyle] = React.useState(getModalStyle);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Grid container justifyContent="flex-end">
            <Modal open={open} onClose={handleClose} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
                <Body modalStyle={modalStyle} handleClose={handleClose} selectedRow={selectedRow} />
            </Modal>
        </Grid>
    );
}
